// Module
var code = "<svg width=\"24\" height=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"5\" width=\"16\" height=\".974\" rx=\".487\" fill=\"#3B3B3B\"/><rect x=\"4\" y=\"12.012\" width=\"16\" height=\".974\" rx=\".487\" fill=\"#3B3B3B\"/><rect x=\"4\" y=\"19.025\" width=\"16\" height=\".974\" rx=\".487\" fill=\"#3B3B3B\"/></svg>";
// Exports
module.exports = code;